import client from 'api/client';
import { AxiosResponse, AxiosRequestConfig } from 'axios';
import { Client } from 'api/models/response/ClientList';

export function get(customConfig?: AxiosRequestConfig): Promise<AxiosResponse> {
    return client.get(`/template_client_list`, customConfig);
}

export function post(payload: FormData, customConfig?: AxiosRequestConfig) {
    return client.post(`upload_client_list`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
        ...customConfig,
    });
}

export function getClientList(
    pageNum?: number,
    pageSize?: number,
    searchInput?: string
): Promise<AxiosResponse<Client[]>> {
    let path = '/clients';
    const params: string[] = [];

    if (pageNum !== undefined) {
        params.push(`page=${pageNum}`);
    }

    if (pageSize !== undefined) {
        params.push(`pageSize=${pageSize}`);
    }

    if (searchInput && searchInput.trim() !== '') {
        params.push(`candidate_name=${searchInput}`);
    }

    if (params.length > 0) {
        path += `?${params.join('&')}`;
    }

    return client.get<Client[]>(path);
}

export function getClientListBySearchInput(
    pageNum?: number,
    pageSize?: number,
    searchInput?: string
): Promise<AxiosResponse<Client[]>> {
    return client.get<Client[]>(
        `/clients?page=${pageNum}&pageSize=${pageSize} ${
            searchInput ? `&candidate_name=${searchInput}` : ''
        }`
    );
}

export function getClientById(id: number): Promise<AxiosResponse<Client>> {
    const path = `/client-list/${id}`;
    return client.get<Client>(path);
}
